import React, { createContext } from 'react';
import { DocumentTitle } from 'components/media/DocumentPreview/components/DocumentTitle';
import { Preview } from 'components/media/DocumentPreview/components/Preview';
import { VideoPreview } from 'components/media/DocumentPreview/components/VideoPreview';
import { Actions } from 'components/media/DocumentPreview/components/Actions';
import styles from './styles.module.scss';

export const DocumentPreviewContext = createContext(null);

export const DocumentPreview = ({ url, name, intl, children, downloadName }) => (
  <DocumentPreviewContext.Provider value={{ url, name, intl, downloadName }}>
    <div className={styles.documentPreview}>
      {children}
    </div>
  </DocumentPreviewContext.Provider>
);

DocumentPreview.DocumentTitle = DocumentTitle;
DocumentPreview.Preview = Preview;
DocumentPreview.VideoPreview = VideoPreview;
DocumentPreview.Actions = Actions;

